module.exports = __webpack_public_path__ + "static/media/GR8Conf.d4cdd34d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GR8Conf.svg
// module id = 453
// module chunks = 0